module.exports = __webpack_public_path__ + "assets/images/nav-home.48d5d423533b844e9db6b4d78dcc92cb.svg";